// Cross-layer signal for a push notification arriving while the app is open.
// pushClient (framework-agnostic) dispatches this window event; the React
// notifications provider listens to bump the bell and show an in-app banner.

export const NOTIFICATION_RECEIVED_EVENT = "pawseum:notification-received";

export interface NotificationReceivedDetail {
  title: string;
  body: string;
  data: Record<string, string>;
}

export function dispatchNotificationReceived(
  detail: NotificationReceivedDetail,
): void {
  if (typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent<NotificationReceivedDetail>(NOTIFICATION_RECEIVED_EVENT, {
      detail,
    }),
  );
}
